import { handleActions } from 'redux-actions';
import { Actions, websocketConnected, websocketConnecting } from 'actions/websocketActions';
import { UtcTime } from 'shared/models';

export type State = Readonly<{
    connecting: boolean;
    connectingSince: UtcTime | null;
    connected: boolean;
    connectedSince: UtcTime | null;
    disconnectedSince: UtcTime | null;
}>;

export const initialState = Object.freeze<State>({
    connecting: false,
    connectingSince: null,
    connected: false,
    connectedSince: null,
    disconnectedSince: null,
});

export const websocketsReducer = handleActions({
    [Actions.WEBSOCKET_CONNECTING]: (state: State, action: ReturnType<typeof websocketConnecting>): State => {
        return {
            ...state,
            connecting: true,
            connectingSince: action.meta.started,
            connected: false,
            disconnectedSince: state.connected ? action.meta.started : state.disconnectedSince,
        };
    },
    [Actions.WEBSOCKET_CONNECTED]: (state: State, action: ReturnType<typeof websocketConnected>): State => {
        const connected = action.payload;
        const { when } = action.meta;
        return {
            ...state,
            connecting: false,
            connectingSince: null,
            connected,
            connectedSince: connected ? when : null,
            disconnectedSince:
                connected
                    ? null
                    : state.connecting
                        ? state.disconnectedSince // If we only disconnected from a connecting attempt then use the previous disconnected time
                        : when,
        };
    },
} as any, initialState);
